export default "__VITE_ASSET__CcnFTBk6__"